import { useShallow } from 'zustand/react/shallow';
import { ReactElement } from 'react';
import { useTreeStore } from '@/frontend/store/TreeStore';
import { GenericSideNav } from './GenericSideNav';
import { ProcedureProgressBar } from './ProgressBar';
import DraggableTree from './DraggableTree';

type SideNavProps = {
  rootName: string;
  link: ReactElement;
  isScaffold?: boolean;
  hideProgress?: boolean;
};

export function SideNav({rootName, link, isScaffold = false, hideProgress = false }: SideNavProps) {
  const treeState = useTreeStore(useShallow((store) => store.getTreeState(isScaffold)));
  const reorder = useTreeStore((store) => store.reorderContainers);

  return (
    <GenericSideNav title={rootName} link={link}>
      <div className='w-100 overflow-scroll' style={{ maxHeight: '100vh', height: '100vh' }}>
        { !hideProgress && <ProcedureProgressBar isScaffold={isScaffold} /> }
        <div style={{ flexGrow: '1' }} className='w-100'>
          <DraggableTree hideProgress={hideProgress} treeState={treeState} reorder={(targetContainerId, movingContainerId, action) => void reorder(targetContainerId, movingContainerId, action)} />
        </div>
      </div>
    </GenericSideNav>
  );
}
